
const validateClaim = (values) => {
  const errors = {};

  if (!values.clinicianId) {
    if (!Number.isInteger(values.clinicianId)) {
      errors.clinicianId = 'Please select an option';
    }
  }

  if (!values.renderingProviderId) {
    if (!Number.isInteger(values.renderingProviderId)) {
      errors.renderingProviderId = 'Please select an option';
    }
  }


  if (!values.serviceLocationId) {
    if (!Number.isInteger(values.serviceLocationId)) {
      errors.serviceLocationId = 'Please select an option';
    }
  }

  return errors;
};


export default validateClaim;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ValidateClaim.js